<auto-main-navigation [accountId]="accountId"></auto-main-navigation>

<p-panel>
  <p-header class="settings-header-wrapper">
    <h1 class="settings-header">Inventory Settings</h1>
  </p-header>

  <div class="main-content-wrapper p-grid">
    <div class="p-col-4">
      <p-panelMenu [model]="settingsSideNav">
      </p-panelMenu>
    </div>

    <p-panel class="p-col ad-types-wrapper">
      <p-header class="account-inventory-header-wrapper">
        <h2 class="ad-types-header-text">{{this.activeBusinessCategoryName}} Inventory URLs</h2>
      </p-header>
      <p-tabs class="business-category-tabs" [(value)]="activeBusinessCategoryKey">
        <p-tablist>
          @for (item of businessCategoryTabs; track item) {
            <p-tab
              [value]="getBusinessCategoryKey(item)"
              (click)="onBusinessCategoryTabClick(item)"
              class="flex items-center"
            >
              <span>{{ item.label }}</span>
            </p-tab>
          }
        </p-tablist>
      </p-tabs>

      @if (this.activeBusinessCategoryName == 'New') {
        <div>
          <div class="p-grid field-form-wrapper">
            <div class="p-col-4 field-form-inputs-wrapper" style="margin: auto 0">
              <label> URL Template </label>
            </div>
            <div class="p-col-7 value-input-wrapper">
              <input
                type="text"
                pInputText [(ngModel)]="ncsAutoPopulateField"
                class="text-input"/>
            </div>
            <button pButton
              class="p-button-success auto-populate-wrapper"
              label="Auto-Populate"
              (click)="autoPopulate('New')">
            </button>
          </div>
          <p-card class="p-col" [style]="{'border-style': 'solid', 'border-color':'lightgray', 'border-width': 'thin'}">
            <div class="p-grid field-form-wrapper">
              @if (ncsAccountInventoryUrl) {
                <form [formGroup]="ncsAccountInventoryUrlMainFormGroup" autoTrackUnsavedChanges class="p-col">
                  <div formArrayName="ncsAccountInventoryUrlFormArray">
                    @for (ncsAccountInventoryUrl of this.ncsAccountInventoryUrlFormArray.controls; track ncsAccountInventoryUrl; let i = $index) {
                      <div>
                        @if (this.ncsMakes[i]) {
                          <div>
                            <h2>{{this.ncsMakes[i]}}</h2>
                            <br>
                            </div>
                          }
                          <div [formGroupName]="i" class="p-grid">
                            <div class="p-col-4 field-form-inputs-wrapper" style="margin: auto 0">
                              <label> {{ncsAccountInventoryUrl.value.make}} {{ncsAccountInventoryUrl.value.model}} </label>
                            </div>
                            <div class="p-col-7 value-input-wrapper">
                              <input
                                id="ncsValue"
                                type="text"
                                pInputText
                                class="text-input"
                                formControlName="url"/>
                            </div>
                          </div>
                        </div>
                      }
                      <button pButton
                        class="p-button-success save-button-wrapper"
                        label="Save"
                        (click)="handleAccountInventorySave('New')"
                        [disabled]="this.ncsAccountInventoryUrlMainFormGroup.pristine || this.saveInProgress">
                      </button>
                    </div>
                  </form>
                }
              </div>
            </p-card>
          </div>
        }
        @if (this.activeBusinessCategoryName === 'Used') {
          <div>
            <div class="p-grid field-form-wrapper">
              <div class="p-col-4 field-form-inputs-wrapper" style="margin: auto 0">
                <label> URL Template </label>
              </div>
              <div class="p-col-7 value-input-wrapper">
                <input
                  type="text"
                  pInputText [(ngModel)]="ucsAutoPopulateField"
                  class="text-input"/>
              </div>
              <button pButton
                class="p-button-success auto-populate-wrapper"
                label="Auto-Populate"
                (click)="autoPopulate('Used')">
              </button>
            </div>
            <p-card class="p-col" [style]="{'border-style': 'solid', 'border-color':'lightgray', 'border-width': 'thin'}">
              <div class="p-grid field-form-wrapper">
                @if (ucsAccountInventoryUrl) {
                  <form [formGroup]="ucsAccountInventoryUrlMainFormGroup" autoTrackUnsavedChanges class="p-col">
                    <div formArrayName="ucsAccountInventoryUrlFormArray">
                      @for (ucsAccountInventoryUrl of this.ucsAccountInventoryUrlFormArray.controls; track ucsAccountInventoryUrl; let i = $index) {
                        <div>
                          @if (this.ucsMakes[i]) {
                            <div>
                              <h2>{{this.ucsMakes[i]}}</h2>
                              <br>
                              </div>
                            }
                            <div [formGroupName]="i" class="p-grid">
                              <div class="p-col-4 field-form-inputs-wrapper" style="margin: auto 0">
                                <label> {{ucsAccountInventoryUrl.value.make}} {{ucsAccountInventoryUrl.value.model}} </label>
                              </div>
                              <div class="p-col-7 value-input-wrapper">
                                <input
                                  id="ucsValue"
                                  type="text"
                                  pInputText
                                  class="text-input"
                                  formControlName="url"/>
                              </div>
                            </div>
                          </div>
                        }
                        <button pButton
                          class="p-button-success save-button-wrapper"
                          label="Save"
                          (click)="handleAccountInventorySave('Used')"
                          [disabled]="this.ucsAccountInventoryUrlMainFormGroup.pristine || this.saveInProgress">
                        </button>
                      </div>
                    </form>
                  }
                </div>
              </p-card>
            </div>
          }
        </p-panel>
      </div>
    </p-panel>
    <auto-footer></auto-footer>
